<template>
  <div class="hh-auth-error-page">
    <div class="hh-auth-error-container">
      <div class="hh-auth-error-card">
        <img src="@/assets/img/warning-red.svg" alt="warning" class="hh-auth-error-icon" />
        <h2 class="hh-auth-error-title">
          {{ $t('authErrorTitle') }}
        </h2>
        <p class="hh-auth-error-text">
          {{ $t('authErrorText') }}
        </p>
        <VBtn
          class="hh-auth-error-button"
          color="success"
          @click="goToDashboard"
        >
          {{ $t('authErrorButton') }}
        </VBtn>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HHAuthorizationError',
  methods: {
    goToDashboard() {
      this.$router.push({ name: 'dashboard' });
    },
  },
  metaInfo() {
    return {
      title: this.$t('authErrorPageTitle'),
    };
  },
};
</script>

<style lang="scss" scoped>
.hh-auth-error-page {
  padding: 1.5rem;
}

.hh-auth-error-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: calc(100vh - 10rem);
  padding: 2rem;
}

.hh-auth-error-card {
  width: 430px;
  border-radius: 8px;
  background: #F5F5F5;
  padding: 20px 25px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.hh-auth-error-icon {
  margin-bottom: 20px;
  width: 50px;
  height: 50px;
  background-color: rgba(234, 13, 13, 0.1);
  border-radius: 50%;
  padding: 12px;
  box-sizing: border-box;
}

.hh-auth-error-title {
  font-size: 24px;
  font-weight: 400;
  line-height: 110%;
  color: #212121;
  margin: 0 0 20px 0;
}

.hh-auth-error-text {
  font-size: 16px;
  font-weight: 300;
  line-height: 140%;
  color: #212121;
  margin: 0 0 20px 0;
}

.hh-auth-error-button {
  width: 100% !important;
  height: 43px !important;
  font-size: 16px !important;
  line-height: 120% !important;
  font-weight: 400 !important;
  border-radius: 4px !important;
  padding: 12px !important;

  &:hover {
    background-color: rgba(31, 197, 127, 0.9) !important;
  }
}
</style>

<i18n locale="en" lang="yaml">
  authErrorPageTitle: Authorization Error
  authErrorTitle: Authorization Error
  authErrorText: Check your login and password and try again
  authErrorButton: Return to Home
</i18n>

<i18n locale="ru" lang="yaml">
  authErrorPageTitle: Ошибка авторизации
  authErrorTitle: Ошибка авторизации
  authErrorText: Проверьте логин и пароль и попробуйте ещё раз
  authErrorButton: Вернуться на главную
</i18n>
